import React from 'react';
import { parse } from "query-string";
import jwtDecode from "jwt-decode";
import http from "../Common/RestAPIHandler";
import { triggerThemeUpdate } from "../Common/Utility";
import auth from "../../services/authService";
import { setUser } from "../../redux-tools/actions/userActions";
import { connect } from "react-redux";
import Logo from "../../Images/logo.png";
import useStyles from "./style";
import { Grid, Typography, Link, Button } from "@material-ui/core";
import { Link as RouterLink } from "react-router-dom";
import Alert from "@material-ui/lab/Alert";
import { TextValidator, ValidatorForm } from "react-material-ui-form-validator";
import commonConstants from "../Common/CommonConstants";

function OneLoginAuth(props) {
  const classes = useStyles();
  const [user, setUser] = React.useState();
  const [errors, setErrors] = React.useState({});
  const errorText = commonConstants.error;

  React.useEffect(() => {
    const hash = parse(window.location.hash);
    if(hash && hash.id_token){
      const idToken = jwtDecode(hash.id_token);
      http.Get(
        `onelogin_sso?onelogin_id=${idToken.sub}`,
        (response) => {
          auth.saveToken(response.access_token);
          if (response.theme === "Light") {
            localStorage.setItem("isDarkEnabled", false);
          } else {
            localStorage.setItem("isDarkEnabled", true);
          }
          localStorage.setItem(
            "colorScheme",
            JSON.stringify(response.colour_scheme || "Orange")
          );
          localStorage.setItem("date_format", response.date_format);
          localStorage.setItem("date_time_format", response.date_time_format);
          localStorage.setItem("notification_days", response.notification_days);
          triggerThemeUpdate(); // Update theme immediately
          if(response.login_authorized){
            props.setUser(response);
            props.history.replace(process.env.PUBLIC_URL + "/dashboard");
          }
          else{
            // Store user data temporarily for 2FA to access, but don't set in Redux yet
            sessionStorage.setItem('temp_user_data', JSON.stringify(response));
            props.history.replace(process.env.PUBLIC_URL + "/twoFA");
          }
        },
        () => {
          setUser({"email":idToken.email,"onelogin_id":idToken.sub});
        }
      );
    }
    else{
      props.history.replace(process.env.PUBLIC_URL + "/passwordlogin");
    }
  }, [props]);



  return (
    <div className={classes.main}>
    {user &&
     <div className={classes.root}>   
      <ValidatorForm onSubmit={()=>{
        http.Post(
          "onelogin_sso",
          user,
          (response) => {
            auth.saveToken(response.access_token);
            if (response.theme === "Light") {
              localStorage.setItem("isDarkEnabled", false);
            } else {
              localStorage.setItem("isDarkEnabled", true);
            }
            localStorage.setItem(
              "colorScheme",
              JSON.stringify(response.colour_scheme || "Orange")
            );
            localStorage.setItem("date_format", response.date_format);
            localStorage.setItem("date_time_format", response.date_time_format);
            localStorage.setItem("notification_days", response.notification_days);
            triggerThemeUpdate(); // Update theme immediately
            if (response.login_authorized) {
              props.setUser(response);
              props.history.replace(process.env.PUBLIC_URL + "/dashboard");
            }
            else{
              // Store user data temporarily for 2FA to access, but don't set in Redux yet
              sessionStorage.setItem('temp_user_data', JSON.stringify(response));
              props.history.replace(process.env.PUBLIC_URL + "/twoFA");
            }
          },
          (status, error) => {
            setErrors(error);
            if (error.invalid_email_password) {
              http.Post(
                "user_session/lock/?user_type=Tenant User",
                user,
                () => {},
                () => {}
              );
            }
          }
        );
      }}>    
        <Grid
          container
          spacing={0}
          alignItems="center"
          justify="center"
          className={classes.container}
        >
          
          <Grid item xs={12}>
            <Grid container spacing={3}>
              <Grid item xs={12} className={classes.centerElement}>
                <Typography variant="h6" color="inherit" noWrap>
                  <img
                    src={Logo}
                    alt="Not Available"
                    className={classes.logo}
                  />
                </Typography>
              </Grid>
              <Grid item xs={12}>
                <Typography
                  variant="h4"
                  component="h5"
                  color="textSecondary"
                  classes={{ h4: classes.title }}
                >                  
                  No SSO setup for this user!<br/>
                  Please login first:<br/>
                </Typography>
              </Grid>
              <Grid item xs={12}>
                <TextValidator
                  id="outlined-email-input"
                  label="E-mail"
                  type="text"
                  name="email"
                  variant="outlined"
                  fullWidth
                  value={user.email || ""}
                  onChange={(e)=>{setUser({...user,"email":e.target.value});}}
                  validators={["required", "trim", "isEmail"]}
                  errorMessages={[
                    errorText.requiredError,
                    errorText.blankError,
                    errorText.invalidEmailError,
                  ]}
                />
              </Grid>                   
              <Grid item xs={12}>
                <TextValidator
                  id="outlined-password-input"
                  label="Password"
                  type="password"
                  name="password"
                  variant="outlined"
                  className={classes.passwordField}
                  fullWidth
                  inputProps={{ style: { fontWeight: "bold" } }}
                  value={user.password || ""}
                  onChange={(e)=>{setUser({...user,"password":e.target.value});}}
                  validators={["required"]}
                  errorMessages={[errorText.requiredError]}
                />
              </Grid>

              {errors && errors.invalid_email_password && (
                <Grid item xs={12}>
                  <Alert severity="error" variant="filled">
                    {errors.invalid_email_password}
                  </Alert>
                </Grid>
              )}

              {errors && errors.lockout && (
                <Grid item xs={12}>
                  <Alert severity="error" variant="filled">
                    {errors.lockout}
                  </Alert>
                </Grid>
              )}
              <Grid item xs={12}>
                <Grid container spacing={3}>
                  <Grid item xs={6}>
                    <Link
                      component={RouterLink}
                      to={process.env.PUBLIC_URL + "/forgetPassword?userType=Tenant User"}
                      color="textPrimary"
                      className={classes.link}
                    >
                      Forgot password?
                    </Link>
                  </Grid>
                  <Grid item xs={6} className={classes.rightElement}>
                    <Button
                      type="submit"
                      className={classes.button}
                      variant="outlined"
                    >
                      Login
                    </Button>
                  </Grid>
                </Grid>
              </Grid>
            </Grid>
          </Grid>
        </Grid>
      </ValidatorForm>
     </div>
    }
    </div>
  )
}

export default connect(null, { setUser })(OneLoginAuth);